export const roundToTwoDecimals = (num: number) => Math.round((num + Number.EPSILON) * 100) / 100;
export const localeRound = (num: number, opt?: { decimals: number; minDecimals: number; }) =>
  new Intl.NumberFormat('nb', {
    maximumFractionDigits: opt?.decimals || 2,
    minimumFractionDigits: opt?.minDecimals || opt?.decimals || 2
  })
    .format(num);
